$(document).ready(function(){

$('.owl-carousel').owlCarousel({
    loop:true,
    margin:40,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false,
          margin:0,
        },
        1000:{
            items:4,
            nav:true,
            loop:false
        }
    }
})


});